var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32150_46988)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.30542 8.75024C4.10986 8.55462 4 8.28934 4 8.01274C4 7.73613 4.10986 7.47085 4.30542 7.27523L10.2065 1.37413C10.3028 1.27449 10.4179 1.19502 10.5451 1.14035C10.6724 1.08568 10.8093 1.05691 10.9478 1.0557C11.0863 1.0545 11.2237 1.08089 11.3519 1.13334C11.4801 1.18579 11.5965 1.26325 11.6945 1.3612C11.7924 1.45914 11.8699 1.57561 11.9223 1.70381C11.9748 1.83201 12.0012 1.96937 12 2.10788C11.9988 2.24639 11.97 2.38327 11.9153 2.51054C11.8606 2.63781 11.7812 2.75291 11.6815 2.84914L6.51794 8.01274L11.6815 13.1763C11.8716 13.3731 11.9767 13.6366 11.9743 13.9101C11.9719 14.1836 11.8622 14.4452 11.6688 14.6386C11.4754 14.832 11.2138 14.9418 10.9403 14.9441C10.6668 14.9465 10.4033 14.8414 10.2065 14.6513L4.30542 8.75024Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32150_46988"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.2b689a5b61eab2ecd2be2065b61f1099.svg";
export { ForwardRef as ReactComponent };